export default __webpack_public_path__ + "static/logo5-3ec7ba428341a0831b6f85160922187e.png";